<template>
	<span style="cursor: pointer" @click="openWaze">
		<span>{{ address }}</span>
		<v-icon v-if="address">mdi-waze</v-icon>
	</span>
</template>

<script>
	export default {
		name: "waze-link",
		props: ["address", "waze"],
		computed: {
			wazehref() {
				return ("https://waze.com/ul?q=" + this.waze);
			}
		},
		methods: {
			openWaze() {
				window.open(this.wazehref, "_blank");
			}
		}
	};
</script>